/*************************************************/
/* HEADER                                        */
/*************************************************/
export function header(body) {
  let headerElement;
  const headerSelector = ".header";
  const headerStickyClass = "header-sticky";
  let scrollTimer;
  let lastScrollTop = 0;
  let isScrollingUp = false;
  const menuButtonSelector = ".menu-nav-mobile__btn";
  const offcanvasSelector = "#mobile-menu";
  const backdropClass = "offcanvas-backdrop";
  const menuItems = document.querySelectorAll('ul.mobile-menu__main > li.mobile-menu__main__item--lvl-2');
  const languageSelectorSelector = ".language-selector";
  const visibleClass = "language-selector--visible";

  if (menuItems.length) {
    menuItems[menuItems.length - 1].style.marginBottom = '25px';
  }

  const setStickyHeader = () => {
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const headerHeight = headerElement.offsetHeight;
    headerElement = document.querySelector(headerSelector);
    const languageSelector = document.querySelector(languageSelectorSelector);

    // Determine scroll direction
    isScrollingUp = currentScrollTop < lastScrollTop;

    // At the top of the page - always show header, remove sticky
    if (currentScrollTop <= headerHeight / 2) {
      body.classList.remove(headerStickyClass);
      headerElement.style.transform = "translateY(0)";
    }
    // Past header height - apply sticky behavior based on scroll direction
    else if (currentScrollTop > headerHeight / 2) {
      body.classList.add(headerStickyClass);
      if (isScrollingUp) {
        // Scrolling up - show sticky header
        body.classList.add(headerStickyClass);
        headerElement.style.transform = "translateY(0)";
      } else {
        // Scrolling down - hide sticky header
        body.classList.remove(headerStickyClass);
        headerElement.style.transform = "translateY(-100%)";
        if (languageSelector) {
          languageSelector.classList.remove(visibleClass);
        }
      }
    }

    lastScrollTop = currentScrollTop;
  };

  const createBackdrop = () => {
    let backdrop = document.createElement("div");
    backdrop.classList.add(backdropClass);
    document.body.appendChild(backdrop);
    backdrop.addEventListener("click", () => toggleOffcanvas(false));
    return backdrop;
  };

  const toggleOffcanvas = (forceOpen = null) => {
    const menu = document.querySelector(offcanvasSelector);
    const backdrop =
      document.querySelector(`.${backdropClass}`) || createBackdrop();
    const isOpen = menu.classList.contains("is-open");
    const shouldOpen = forceOpen !== null ? forceOpen : !isOpen;

    if (shouldOpen) {
      menu.classList.add("is-open");
      backdrop.classList.add("is-visible");
      document.body.style.overflow = "hidden"; // prevent background scroll
    } else {
      menu.classList.remove("is-open");
      backdrop.classList.remove("is-visible");
      document.body.style.overflow = ""; // re-enable scroll
    }
  };

  const init = () => {
    headerElement = document.querySelector(headerSelector);
    if (!headerElement) {
      console.warn('Header element not found');
      return;
    }

    // Add smooth transition styles to header
    headerElement.style.transition = "transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)";
    headerElement.style.willChange = "transform";

    // Initialize scroll position
    lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    // Sticky header
    setStickyHeader();
    window.addEventListener("scroll", (e) => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        setStickyHeader();
      }, 10);
    });

    // Offcanvas toggle
    const menuButton = document.querySelector(menuButtonSelector);
    if (menuButton) {
      menuButton.addEventListener("click", () => toggleOffcanvas());
    }

    // Offcanvas close button inside menu
    const closeBtn = document.querySelector("#mobile-menu .mobile-menu__close");
    if (closeBtn) {
      closeBtn.addEventListener("click", () => toggleOffcanvas(false));
    }
  };

  init();
}